const Calendar = (props) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 2a1 1 0 0 1 1 1v1h8V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1Zm9 4v1a1 1 0 1 0 2 0V6h1a1 1 0 0 1 1 1v3H4V7a1 1 0 0 1 1-1h1v1a1 1 0 0 0 2 0V6h8ZM4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7H4Z"
      fill="#335683"
    />
  </svg>
);

export default Calendar;
